import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import {
    getListViewByVisibleRange,
    deleteViewData,
    updateViewData,
    getViewById,
    getListViewByOfVisibleProject,
    editViewsResourceAPI
} from '@/service/viewService';
import localStorageUtil from '@/common/utils/localStorageUtil';

export const getVisibleRangeByVisibleType = (visibleType, argsCommon) => {
    let visibleRange = '';
    switch (visibleType) {
        case Constant.VISIBILITY_SETTING_TYPE.PRIVATE:
            visibleRange = argsCommon.userDetail.id;
            break;
        case Constant.VISIBILITY_SETTING_TYPE.PROJECT:
        case Constant.VISIBILITY_SETTING_TYPE.CUSTOMER:
            visibleRange = argsCommon.projectSelectedId;
            break;
        case Constant.VISIBILITY_SETTING_TYPE.IN_ORG:
            visibleRange = argsCommon?.corporationSelectedId;
            break;

        default:
            break;
    }

    return visibleRange;
};

export const sortListViewByOrder = listView => {
    return listView.sort((viewA, viewB) => {
        return viewA.order - viewB.order;
    });
};

export const sortListViewByOrderInProject = (listView, userId) => {
    if (!listView || !Array.isArray(listView)) {
        return listView;
    }
    // userId may be undefined (e.g. IN_ORG views without user context) —
    // in that case all views fall through to createdAt sort, which is intentional.
    return [...listView].sort((a, b) => {
        const sortDataA = Utils.convertJSONDataToObject(a.sortData);
        const sortDataB = Utils.convertJSONDataToObject(b.sortData);
        const orderA = sortDataA?.[userId];
        const orderB = sortDataB?.[userId];
        const hasOrderA = orderA != null;
        const hasOrderB = orderB != null;

        if (hasOrderA !== hasOrderB) return hasOrderA ? -1 : 1;
        if (!hasOrderA && !hasOrderB) {
            return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
        }
        if (orderA !== orderB) return orderA - orderB;
        return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
    });
};

export const getListViews = async (
    argsCommon,
    projectSelectedId,
    visibleType,
    knowledgeInfoChatAi = null,
    setIsScrollNewViews,
    isActionFromDialog = false
) => {
    if (!visibleType || !projectSelectedId) return;
    let visibleRange = getVisibleRangeByVisibleType(visibleType, argsCommon);
    let listView = [];
    if (visibleType === Constant.VISIBILITY_SETTING_TYPE.PROJECT) {
        listView = await getListViewByOfVisibleProject(
            argsCommon?.corporationSelectedId,
            projectSelectedId,
            argsCommon?.userDetail?.id || localStorageUtil.getUserDetailId(),
            Constant.DEFINITION_VIEW.KNOWLEDGE
        );
    } else {
        listView = await getListViewByVisibleRange(
            argsCommon.API,
            projectSelectedId,
            visibleRange,
            visibleType
        );
    }

    if (Utils.isEmptyArray(listView)) {
        return [];
    };

    //sort by order
    if (visibleType === Constant.VISIBILITY_SETTING_TYPE.PROJECT) {
        listView = sortListViewByOrderInProject(listView, argsCommon?.userDetail?.id);
    }else{
        listView = sortListViewByOrder(listView);
    }

    listView.forEach(view => {
        view.isEditName = false;
        view.isMove = false;
    });

    let listViewShow = listView.filter(x => {
        const structure = Utils.convertJSONDataToObject(x.structure);
        if (structure.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
            const limitValue = argsCommon?.corporationDetail?.limitValue;
            let synonymSearch = limitValue?.synonymSearch;

            const projectSetting = Utils.convertJSONDataToObject(
                argsCommon?.projectInuseDetail?.projectSetting
            );

            if (
                argsCommon?.corporationDetail?.contractType ===
                Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
            ) {
                let inviterSetting = Utils.convertJSONDataToObject(
                    argsCommon?.corporationDetail?.inviterSetting
                );
                synonymSearch = inviterSetting.synonymSearch;
            }

            return (
                x.status === Constant.STATUS_VIEW.SHOW &&
                synonymSearch === Constant.STATUS_SERVICE_PERMISSION.ON &&
                projectSetting?.usingSynonym
            );
        }
        return x.status === Constant.STATUS_VIEW.SHOW;
    });

    // let listViewShow = listView.filter((view) => view.status === Constant.STATUS_VIEW.SHOW);

    // if (!Utils.isEmptyObject(argsCommon?.projectInuseDetail)) {
    //     const projectSetting = Utils.convertJSONDataToObject(argsCommon?.projectInuseDetail?.projectSetting);
    //     let usingSynonym = projectSetting?.usingSynonym;
    //     if (!usingSynonym) {
    //         listViewShow = listViewShow.filter(view => {
    //             let structure = Utils.convertJSONDataToObject(view.structure);
    //             return structure.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM
    //         });
    //     }
    // }

    if (!Utils.isEmptyArray(listViewShow) && listViewShow.length > 0) {
        if (isActionFromDialog) {
            argsCommon.setViewSelected(listViewShow[0]);
        }

        let firstViewStructure = Utils.convertJSONDataToObject(listViewShow[0].structure);

        if (knowledgeInfoChatAi) {
            let _viewSelected = listViewShow.find(
                view => view.id === knowledgeInfoChatAi.viewSelectedId
            );
            if (!_viewSelected) {
                argsCommon.setViewStructure({
                    ...firstViewStructure,
                    visibility: visibleType
                });
                argsCommon.setViewSelected(listViewShow[0]);
            } else {
                argsCommon.setViewStructure({
                    ...knowledgeInfoChatAi.viewStructure,
                    visibility: visibleType
                });
                argsCommon.setViewSelected(_viewSelected);
            }
            setIsScrollNewViews(true);
        } else {
            const ticketCreatedProjectId = firstViewStructure?.ticketCreatedProjectId || '';

            if (Utils.isTypeFunction(argsCommon?.setDestinationPrjId)) {
                argsCommon?.setDestinationPrjId(ticketCreatedProjectId);
            }

            argsCommon?.setViewStructure({
                ...firstViewStructure,
                visibility: visibleType,
                ticketCreatedProjectId: ticketCreatedProjectId
            });

            argsCommon?.setViewSelected(listViewShow[0]);
        }
    }
    argsCommon.setListView(listView);

    return listViewShow;
};

export const getViewDefaultsChatAI = async (API, projectId, userDetail) => {
    const visibleType = Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
    if (!projectId) return;

    let listView = await getListViewByVisibleRange(API, projectId, userDetail.id, visibleType);
    if (Utils.isEmptyArray(listView)) {
        return [];
    }
    //sort by order
    listView = sortListViewByOrder(listView);
    listView.forEach(view => {
        view.isEditName = false;
        view.isMove = false;
    });

    let listViewShow = listView.filter(view => view.status === Constant.STATUS_VIEW.SHOW);
    return listViewShow ? listViewShow : [];
};

export const createNewView = async (argsCommon, currentVisibility = '') => {
    let listView = argsCommon.listView;
    // let visibleType = argsCommon.visibilitySetting;
    let visibleTypeSetting = currentVisibility || argsCommon.visibilityKnowledgeAtom;
    let visibleType = visibleTypeSetting;
    let visibleRange = '';
    let order = listView?.length ? listView?.length + 1 : 1;
    switch(visibleTypeSetting){
        case Constant.VISIBILITY_SETTING_TYPE.PRIVATE:
        case Constant.VISIBILITY_SETTING_TYPE.PROJECT:
            visibleType = Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
            visibleRange = argsCommon?.userDetail?.id;
            break;
        case Constant.VISIBILITY_SETTING_TYPE.CUSTOMER:
            order = generateOrderForNewForm(listView);
            visibleRange = argsCommon?.projectSelectedId;
            break;
        case Constant.VISIBILITY_SETTING_TYPE.IN_ORG:
            order = generateOrderForNewForm(listView);
            visibleRange = argsCommon.corporationSelectedId;
            break;
        default:
    }

    //check user role: user is member of projectSelected => create only visibility private
    if (argsCommon.userRoleInProject !== Constant.PRIVILEGE_PROJECT.PRJ_MGR) {
        visibleType = Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
        visibleRange = argsCommon?.userDetail?.id;
    }

    let viewStructure = cloneDeep(argsCommon.viewStructure);
    viewStructure.ticketCreatedProjectId = argsCommon.destinationPrjId || '';
    // Remove visibility option;
    delete viewStructure.visibility;

    // validate new viewName
    let newName = generateNameForNewView(listView, visibleType);
    let listViewLasted = await getListViewByVisibleRange(
        argsCommon.API,
        argsCommon.projectSelectedId,
        visibleRange,
        visibleType
    );

    let listCheck = listViewLasted.filter(v => {
        if(v.visibleType !== visibleType) return false;
        let viewNameObj = JSON.parse(v.name);
        let viewName = viewNameObj['jp'].text;
        viewName = viewName.trim().toLowerCase();

        return viewName.localeCompare(newName.toLowerCase()) === 0;
    });

    if (listCheck?.length) {
        argsCommon.setIsOpenDialogViewChanged(true);
        return;
    }

    let createViewDto = {
        name: {
            jp: {
                A: 'F',
                text: newName
            }
        },
        affiliationOrganization: argsCommon.corporationSelectedId,
        affiliationProject: argsCommon.projectSelectedId,
        affiliationView: '',
        visibleRange: visibleRange,
        visibleType: visibleType,
        structure: viewStructure || {},
        status: Constant.STATUS_VIEW.SHOW,
        viewType: Constant.VIEW_TYPE.CUSTOM,
        order: order,
        definitionView: Constant.DEFINITION_VIEW.KNOWLEDGE,
        creator: argsCommon.userDetail.id,
        updator: argsCommon.userDetail.id
    };

    let createViewResult = await editViewsResourceAPI(argsCommon.API, {method: Constant.UPDATE_VIEW_RESOURCE_METHOD.CREATE_VIEW_WITH_VISIBLE_TYPE, createViewDto: JSON.stringify(createViewDto)});

    if (createViewResult) {
        //update list view
        let listViewClone = cloneDeep(argsCommon.listView);
        listViewClone.push(createViewResult);
        argsCommon.setListView(listViewClone);

        //update view selected is new view
        argsCommon.setViewSelected(createViewResult);
    }
};

export const generateNameForNewView = (listView, visibleType) => {
    let listViewFilter = listView.filter(view => view.visibleType === visibleType);
    let newViewName = '';
    let viewNameDefault = Constant.VIEW_NAME_DEFAULT;

    if (Utils.isEmptyArray(listViewFilter)) {
        newViewName = `${viewNameDefault} 1`;
        return newViewName;
    }

    let maxIndex = BigInt(0);
    let regex = new RegExp(`^${viewNameDefault} (\\d*)+$`, 'g');

    for (const view of listViewFilter) {
        let viewNameObj = JSON.parse(view?.name);
        if (!viewNameObj || typeof viewNameObj !== 'object') continue;
        let viewName = viewNameObj['jp'].text;
        if (Utils.isEmptyString(viewName)) continue;

        let nameMatch = viewName.match(regex);
        if (Utils.isEmptyArray(nameMatch)) continue;

        let indexName = nameMatch[0].replace(`${Constant.VIEW_NAME_DEFAULT} `, '');
        if (Utils.isEmptyString(indexName)) continue;

        let firstChar = indexName.charAt(0);
        if (firstChar === '0') continue;

        indexName = BigInt(indexName);
        if (indexName && indexName > maxIndex) {
            maxIndex = indexName;
        }
    }

    newViewName = `${Constant.VIEW_NAME_DEFAULT} ${maxIndex + 1n}`;

    return newViewName;
};

export const generateOrderForNewForm = listView => {
    if (Utils.isEmptyArray(listView)) {
        return 1;
    }
    let maxOrder = Math.max.apply(
        Math,
        listView.map(view => {
            let order = view.order;
            return order ? order : 0;
        })
    );

    return maxOrder + 1;
};

export const onHandlerDeleteView = async (viewDelete, argsCommon) => {
    argsCommon.setIsConfirmDeleteView(false);
    argsCommon.setIsLoadingView(true);
    // deleteViewData
    let listViewClone = cloneDeep(argsCommon.listView);
    let listViewShow = listViewClone.filter(view => view.status === Constant.STATUS_VIEW.SHOW);

    // delete view in listView
    let indexView = listViewClone.findIndex(view => view.id === viewDelete.id);
    if (indexView !== -1) {
        listViewClone.splice(indexView, 1);
    }
    argsCommon.setListView(listViewClone);

    // delete view in DB
    await deleteViewData(argsCommon.API, viewDelete.id);
    argsCommon.setIsLoadingView(false);

    let indexViewShow = listViewShow.findIndex(view => view.id === viewDelete.id);
    // check case delete current view
    if (argsCommon.viewSelected.id === viewDelete.id && listViewShow.length > 1) {
        if (indexViewShow === 0) {
            let newViewSelected = listViewShow[1];
            if (!Utils.isEmptyObject(newViewSelected)) {
                let currentVisibility = argsCommon.viewStructure.visibility;
                let newView = {
                    ...JSON.parse(newViewSelected.structure),
                    visibility: currentVisibility
                };
                argsCommon.setViewStructure(newView);
                argsCommon.setViewSelected(newViewSelected);
            }
        } else {
            let newViewSelected = listViewShow[indexViewShow - 1];
            if (!Utils.isEmptyObject(newViewSelected)) {
                let currentVisibility = argsCommon.viewStructure.visibility;
                let newView = {
                    ...JSON.parse(newViewSelected.structure),
                    visibility: currentVisibility
                };
                argsCommon.setViewStructure(newView);
                argsCommon.setViewSelected(newViewSelected);
            }
        }
    }
};

export const onHandlerHideView = async (viewHide, argsCommon) => {
    argsCommon.setIsConfirmHideView(false);
    argsCommon.setIsLoadingView(true);

    let listViewClone = cloneDeep(argsCommon.listView);
    let listViewShow = listViewClone.filter(view => view.status === Constant.STATUS_VIEW.SHOW);

    //update view in DB
    await updateViewData(argsCommon.API, viewHide.id, {
        status: Constant.STATUS_VIEW.HIDDEN,
        updator: argsCommon.userDetail?.id
    });

    let indexView = listViewClone.findIndex(view => view.id === viewHide.id);
    if (indexView !== -1) {
        listViewClone[indexView].status = Constant.STATUS_VIEW.HIDDEN;
    }

    if (!Utils.isEmptyObject(argsCommon?.projectInuseDetail)) {
        const projectSetting = Utils.convertJSONDataToObject(
            argsCommon?.projectInuseDetail?.projectSetting
        );
        let usingSynonym = projectSetting?.usingSynonym;
        if (!usingSynonym) {
            listViewShow = listViewShow.filter(view => {
                let structure = Utils.convertJSONDataToObject(view.structure);
                return structure.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM;
            });
        }
    }

    argsCommon.setListView(listViewClone);
    argsCommon.setIsLoadingView(false);

    let indexViewShow = listViewShow.findIndex(view => view.id === viewHide.id);
    //check case hide current view
    if (argsCommon.viewSelected.id === viewHide.id) {
        if (indexViewShow === 0 && listViewShow.length === 1) {
            argsCommon.setViewSelected({});
        } else if (indexViewShow === 0 && listViewShow.length > 1) {
            let newViewSelected = listViewShow[1];
            if (!Utils.isEmptyObject(newViewSelected)) {
                let currentVisibility = argsCommon.viewStructure.visibility;
                let newView = {
                    ...JSON.parse(newViewSelected.structure),
                    visibility: currentVisibility
                };
                argsCommon.setViewStructure(newView);
                argsCommon.setViewSelected(newViewSelected);
            }
        } else if (indexViewShow !== 0 && listViewShow.length > 1) {
            let newViewSelected = listViewShow[indexViewShow - 1];
            if (!Utils.isEmptyObject(newViewSelected)) {
                let currentVisibility = argsCommon.viewStructure.visibility;
                let newView = {
                    ...JSON.parse(newViewSelected.structure),
                    visibility: currentVisibility || Constant.VISIBILITY_SETTING_TYPE.PRIVATE
                };
                argsCommon.setViewStructure(newView);
                argsCommon.setViewSelected(newViewSelected);
            }
        }
    }
};

export const onHandlerShowView = async (viewShow, argsCommon) => {
    argsCommon.setAddViewPopover(null);
    argsCommon.setIsLoadingView(true);

    //check view was changed
    let isViewChanged = await isViewWasChanged(viewShow, argsCommon);
    if (isViewChanged) {
        argsCommon.setIsOpenDialogViewChanged(true);
        return;
    }

    let listViewClone = cloneDeep(argsCommon.listView);

    let indexView = listViewClone.findIndex(view => view.id === viewShow.id);
    if (indexView !== -1) {
        listViewClone[indexView].status = Constant.STATUS_VIEW.SHOW;
    }

    let newStructure = Utils.convertJSONDataToObject(listViewClone[indexView].structure);
    let listViewShow = listViewClone.filter(view => view.status === Constant.STATUS_VIEW.SHOW);
    if (listViewShow.length === 1) {
        let currentVisibility = argsCommon.viewStructure.visibility;
        newStructure.visibility = currentVisibility;
    }
    argsCommon.setViewStructure(newStructure);

    //update view in DB
    await editViewsResourceAPI(argsCommon.API, {
        method: Constant.UPDATE_VIEW_RESOURCE_METHOD.SHOW_VIEW,
        updateViewDto: JSON.stringify({
            viewId: viewShow.id,
            userId: argsCommon.userDetail?.id,
            projectId: argsCommon.projectSelectedId,
            corporationId: argsCommon.corporationSelectedId
        })
    });

    let listViewHide = listViewClone.filter(view => view.status === Constant.STATUS_VIEW.HIDDEN);
    if (listViewHide.length === 0) {
        argsCommon.setOpenListViewHide(false);
    }

    argsCommon.setListView(listViewClone);
    argsCommon.setIsLoadingView(false);
    argsCommon.setViewSelected(listViewClone[indexView]);
    // argsCommon.setTriggerSearch(Date.now().toString());

    scrollToView(viewShow?.id);

    // Update ticketCreatedProjectId
    let ticketCreatedProjectId = newStructure.ticketCreatedProjectId || '';

    // check exist project (ticketCreatedProjectId is deleted ??)
    const organizationProject = argsCommon.organizationProject;
    const existPrjListId = [
        ...organizationProject.externalProjectList,
        ...organizationProject.internalProjectList,
        argsCommon.projectInuseDetail
    ];
    if (!existPrjListId.some(prj => prj.id === ticketCreatedProjectId)) {
        ticketCreatedProjectId = '';
    }

    if (Utils.isTypeFunction(argsCommon?.setDestinationPrjId)) {
        argsCommon?.setDestinationPrjId(ticketCreatedProjectId);
    }
};


export const scrollToView = (viewId) => {
    // Scroll to the view that was just shown
    // Delay to ensure DOM and CSS (fullname display) are updated before scrolling
    setTimeout(() => {
        const viewElement = document.querySelector(`[data-view-id="${viewId}"]`);
        if (viewElement) {
            // Find parent container to scroll
            const container = viewElement.closest('#container-knowledge') || 
                            viewElement.closest('#container');
            
            if (container) {
                // Scroll container to bring selected view into viewport
                const elementRect = viewElement.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                
                // Calculate scroll position to center the selected view
                const scrollLeft = container.scrollLeft + 
                    (elementRect.left - containerRect.left) - 
                    (containerRect.width / 2) + 
                    (elementRect.width / 2);
                
                container.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });
            } else {
                // Fallback: use scrollIntoView if container not found
                viewElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            }
        }
    }, 100); // Increased delay to ensure CSS fullname is applied
}

export const isValidViewName = (newName) => {
    if (!newName) return false;
    if (Utils.countCharacters(newName) > Constant.MAX_LENGTH.VIEW_NAME) return false;
    return true;
}

export const onDoubleClickView = async (view, argsCommon) => {
    clearTimeout(argsCommon?.clickTimeout);
    argsCommon?.setClickTimeout(null);

    if (argsCommon.isCustomer || view.viewType === Constant.VIEW_TYPE.DEFAULT) return;

    if (
        argsCommon.userRoleInProject === 'MEMBER' &&
        view.visibleType === Constant.VISIBILITY_SETTING_TYPE.PROJECT
        && argsCommon.userDetail?.id !== view.creator
    ) {
        return;
    };

    if(view.visibleType !== Constant.VISIBILITY_SETTING_TYPE.PROJECT && view.visibleType !== Constant.VISIBILITY_SETTING_TYPE.PRIVATE && argsCommon.userRoleInProject === 'MEMBER') {
        return; 
    }
    

    if (
        !isDisplayBtnSettingViewIcon(
            argsCommon.isCustomer,
            argsCommon.userRoleInProject,
            {visibility: view.visibleType},
            argsCommon.isViewFromKnowledgePanel
        )
    ) {
        return;
    }

    let listViewClone = cloneDeep(argsCommon.listView);
    let index = listViewClone.findIndex(v => v.id === view.id);

    if (index !== -1) {
        listViewClone[index].isEditName = true;

        let currentName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, view?.name);
        if (!isValidViewName(currentName)) {
            listViewClone[index].isError = true;
        }
    }

    argsCommon.setListView(listViewClone);
};

export const onEnterViewName = async (e, view, argsCommon) => {
    if (e.key === 'Enter') {
        let newName = e.target.value;

        await onEditViewName(view, newName, argsCommon);
    }
};

export const onBlurViewName = async (e, view, argsCommon) => {
    let newName = e.target.value;
    await onEditViewName(view, newName, argsCommon);
};

export const onChangeViewName = (e, view, argsCommon) => {
    const newName = e.target.value;
    const listViewClone = cloneDeep(argsCommon.listView);
    const index = listViewClone.findIndex(v => v.id === view.id);

    if (index !== -1) {
        // Validate length in real-time (does not block input, only shows red border)
        const newIsError = !isValidViewName(newName);
        const currentIsError = listViewClone[index].isError || false;
        
        // Only update state if error status changed (performance optimization)
        if (newIsError !== currentIsError) {
            listViewClone[index].isError = newIsError;
            argsCommon.setListView(listViewClone);
        }
    }
};

export const onEditViewName = async (view, newName, argsCommon) => {
    argsCommon.setIsLoadingView(true);
    //check view was changed
    let viewDetailLatest = await getViewById(argsCommon.API, view.id);
    if (Utils.isEmptyObject(viewDetailLatest)) {
        argsCommon.setIsOpenDialogViewChanged(true);
        argsCommon.setIsLoadingView(false);
    }

    newName = newName.trim();

    let listViewClone = cloneDeep(argsCommon.listView);
    let index = listViewClone.findIndex(v => v.id === view.id);

    // check view name blank
    if (Utils.isEmptyString(newName)) {
        argsCommon.setIsLoadingView(false);
        argsCommon.setViewNameErrorType(Constant.EDIT_VIEW_NAME_ERROR_TYPE.BLANK);
        argsCommon.setIsOpenDialogViewNameError(true);

        listViewClone[index].isError = true;
        argsCommon.setListView(listViewClone);

        return;
    }

    // check view name max length
    if (Utils.countCharacters(newName) > Constant.MAX_LENGTH.VIEW_NAME) {
        argsCommon.setIsLoadingView(false);
        argsCommon.setViewNameErrorType(Constant.EDIT_VIEW_NAME_ERROR_TYPE.MAX_LENGTH);
        argsCommon.setIsOpenDialogViewNameError(true);

        listViewClone[index].isError = true;
        argsCommon.setListView(listViewClone);

        return;
    }

    // check view name not change
    let currentNameObj = JSON.parse(view.name);
    let currentName = currentNameObj['jp'].text;
    currentName = currentName.trim().toLowerCase();
    if (currentName.localeCompare(newName.toLowerCase()) === 0) {
        argsCommon.setIsLoadingView(false);
        listViewClone[index].isEditName = false;
        listViewClone[index].isError = false;
        argsCommon.setListView(listViewClone);

        return;
    }

    let visibleType = view.visibleType === Constant.VISIBILITY_SETTING_TYPE.PRIVATE ? Constant.VISIBILITY_SETTING_TYPE.PRIVATE : argsCommon.viewStructure.visibility;
    let visibleRange = getVisibleRangeByVisibleType(visibleType, argsCommon);

    let listView = await getListViewByVisibleRange(
        argsCommon.API,
        argsCommon.projectSelectedId,
        visibleRange,
        visibleType
    );

    let listCheck = listView.filter(v => {
        if(v.visibleType !== view.visibleType) return false;
        let viewNameObj = JSON.parse(v.name);
        let viewName = viewNameObj['jp'].text;
        viewName = viewName.trim().toLowerCase();

        return viewName.localeCompare(newName.toLowerCase()) === 0 && v.id !== view.id;
    });

    if (!Utils.isEmptyArray(listCheck)) {
        argsCommon.setIsLoadingView(false);
        argsCommon.setViewNameErrorType(Constant.EDIT_VIEW_NAME_ERROR_TYPE.DUPLICATE);
        argsCommon.setIsOpenDialogViewNameError(true);

        listViewClone[index].isError = true;
        argsCommon.setListView(listViewClone);
        return;
    }

    // update ticketCreatedProjectId
    const ticketCreatedProjectId = argsCommon.destinationPrjId || '';
    let structure = Utils.convertJSONDataToObject(view.structure);
    structure = {
        ...structure,
        ticketCreatedProjectId: ticketCreatedProjectId
    };

    // update DB
    await updateViewData(argsCommon.API, view.id, {
        name: JSON.stringify({
            jp: {
                A: 'F',
                text: newName
            }
        }),
        structure: JSON.stringify(structure)
    });

    if (index !== -1) {
        listViewClone[index].name = JSON.stringify({
            jp: {
                A: 'F',
                text: newName
            }
        });
        listViewClone[index].isEditName = false;
        listViewClone[index].isError = false;
        listViewClone[index].structure = JSON.stringify(structure);

        argsCommon.setListView(listViewClone);
    }

    argsCommon.setIsLoadingView(false);
};

export const saveSearchCondition = async (view, argsCommon) => {
    argsCommon.setIsLoadingView(true);
    let viewStructure = cloneDeep(argsCommon.viewStructure);
    //update view in DB
    await updateViewData(argsCommon.API, view.id, {
        structure: viewStructure ? JSON.stringify(viewStructure) : JSON.stringify({})
    });

    //update view in listView
    let listViewClone = cloneDeep(argsCommon.listView);
    let index = listViewClone.findIndex(v => v.id === view.id);
    listViewClone[index].structure = viewStructure
        ? JSON.stringify(viewStructure)
        : JSON.stringify({});
    argsCommon.setListView(listViewClone);

    //update viewSelected
    let viewSelectedClone = cloneDeep(argsCommon.viewSelected);
    viewSelectedClone.structure = viewStructure
        ? JSON.stringify(viewStructure)
        : JSON.stringify({});
    argsCommon.setViewSelected(viewSelectedClone);
    argsCommon?.setViewStructure(viewStructure);

    argsCommon.setIsLoadingView(false);
};

export const isViewWasChanged = async (view, argsCommon) => {
    try {
        argsCommon.setIsLoadingView(true);
        let viewDetailLatest = await getViewById(argsCommon.API, view.id);

        // check change view
        let isChangeView =
            Utils.isEmptyObject(viewDetailLatest) ||
            (viewDetailLatest.status !== view.status &&
                viewDetailLatest.updator !== argsCommon.userDetail?.id);

        argsCommon.setIsLoadingView(false);
        return isChangeView;
    } catch (error) {
        console.log('isViewWasChanged err >>>', error);
        argsCommon.setIsLoadingView(false);
    }
};

export const onClickOpenMoveView = (view, argsCommon) => {
    let listViewClone = cloneDeep(argsCommon.listView);

    // only one view isMove
    listViewClone.forEach(thisView => {
        if (thisView.id === view.id) {
            thisView.isMove = true;
        } else {
            thisView.isMove = false;
        }
    });

    argsCommon.setListView(listViewClone);
};

export const onChangeVisibilitySetting = (visibility, argsCommon) => {
    argsCommon.setIsLoadingView(true);
    // let visibilitySettingValue = event.target.value;
    let visibilitySettingValue = visibility;
    // setVisibilitySetting(visibilitySettingValue);

    // Update visibility in recoil state
    let currentViewStructure = cloneDeep(argsCommon.viewStructure);
    currentViewStructure.visibility = visibilitySettingValue;
    argsCommon.setViewStructure(currentViewStructure);
    argsCommon.setIsLoadingView(false);
};

export const onChangeViewSelected = (view, argsCommon, currentCorporationDetail) => {
    if (argsCommon?.clickTimeout) {
        clearTimeout(argsCommon?.clickTimeout);
        argsCommon?.setClickTimeout(null);
        return;
    }

    const loadingChangeViewSelected = () => {
        argsCommon?.setClickTimeout(null);
        argsCommon.setFileNamePdfSelect('');
        argsCommon.setViewSelected(view);
        let limitValue = currentCorporationDetail?.limitValue;
        let usingChatAI = limitValue?.usingChatAI;
        let structureTmp = Utils.convertJSONDataToObject(view.structure);
        let structure = cloneDeep(structureTmp);
        let isChangeOptionStruct =
            usingChatAI === 0 &&
            structure.options.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR;
        if (
            [
                Constant.CORPORATION_CONTRACT_TYPE.GUEST,
                Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
            ].includes(currentCorporationDetail.contractType)
        ) {
            isChangeOptionStruct =
                currentCorporationDetail.inviterUsingChatAI === 0 &&
                structure.options.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR;
        }
        if (isChangeOptionStruct) {
            structure.options.sort = Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;
            structure.options.method = Constant.SETTING_SEARCH_KEYWORD.AND;
        }
        if (structure?.options?.isIncludePdfFile || structure?.options?.isIncludePdfPage) {
            structure.isIncludePdfFile = 0;
            structure.isIncludePdfPage = 0;
            if (structure?.options?.sort === Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.PAGE_NO) {
                structure.options.sort = Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;
            }
        }
        if (structure?.options?.isIncludeAttachPdf) {
            structure.isIncludeAttachPdf = 0;
        }
        let currentVisibility = argsCommon.viewStructure.visibility;
        let newView = {
            ...structure,
            visibility: currentVisibility
        };
        argsCommon.setViewStructure(newView);
        // argsCommon.setTriggerSearch(Date.now().toString());

        let ticketCreatedProjectId = structure.ticketCreatedProjectId || '';

        // check exist project (ticketCreatedProjectId is deleted ??)
        const organizationProject = argsCommon.organizationProject;
        const existPrjListId = [
            ...organizationProject.externalProjectList,
            ...organizationProject.internalProjectList,
            argsCommon.projectInuseDetail
        ];
        if (!existPrjListId.some(prj => prj.id === ticketCreatedProjectId)) {
            ticketCreatedProjectId = '';
        }

        if (Utils.isTypeFunction(argsCommon?.setDestinationPrjId)) {
            argsCommon?.setDestinationPrjId(ticketCreatedProjectId);
        }

        // if click to current view selected -> trigger reload with default search condition.
        if (view.id === argsCommon.viewSelected.id) {
            argsCommon.setTriggerSearch(Date.now().toString());
        }
        argsCommon?.setClickTimeout(null);
    };

    //handle set timeout to cover for click and double click in same element
    if (view.id === argsCommon.viewSelected.id) {
        const timeout = setTimeout(() => {
            loadingChangeViewSelected();
        }, 300);
        argsCommon?.setClickTimeout(timeout);
    } else {
        loadingChangeViewSelected();
    }
};

export const onBeforeDragStartHandler = (event, argsCommon) => {
    //disable slide before drag start
    let newSetting = { ...argsCommon.settingSlideRecoilState };
    newSetting.disable = true;

    argsCommon.setSettingSlideRecoilState(newSetting);
};

export const updateViewOrderForProject = async (listViewClone, userId, argsCommon) => {
    let order = 1;
    let updateOrderListViewData = [];
    listViewClone.forEach(view => {
        // Initialize sortData if it doesn't exist
        if (!view.sortData) {
            view.sortData = {};
        }
        // Update sortData for current user
        updateOrderListViewData.push({
            id: view.id,
            userId: userId,
            order: order
        });
        order++;
    });
    await argsCommon.setListView(listViewClone);
    // update view in DB with sortData
    argsCommon.setIsLoadingView(true);

    const payload = { updateType: Constant.UPDATE_ORDER_VIEW_TYPE.SORT_DATA, orderList: updateOrderListViewData };
    const inOrgViews = listViewClone.filter(v => v.visibleType === Constant.VISIBILITY_SETTING_TYPE.IN_ORG);
    if (inOrgViews.length > 0) {
        payload.syncInOrg = {
            corporationId: argsCommon.corporationSelectedId,
            projectId: argsCommon.projectSelectedId,
            reorderedInOrgViewIds: inOrgViews.map(v => v.id),
            triggerSource: Constant.SYNC_TRIGGER_SOURCE.PROJECT
        };
    }
    await editViewsResourceAPI(argsCommon.API, {
        method: Constant.UPDATE_VIEW_RESOURCE_METHOD.UPDATE_ORDER_VIEW_KNOWLEDGE,
        updateViewDto: JSON.stringify(payload)
    });
    argsCommon.setIsLoadingView(false);
};

export const updateViewOrderForOtherVisibility = async (listViewClone, argsCommon) => {
    // Original logic for other visibility types
    let order = 1;
    listViewClone.forEach(view => {
        view.order = order;
        order++;
    });
    await argsCommon.setListView(listViewClone);

    // update view in DB
    argsCommon.setIsLoadingView(true);
    const payload = {
        updateType: Constant.UPDATE_ORDER_VIEW_TYPE.ORDER,
        orderList: listViewClone.map(v => ({ id: v.id, order: v.order }))
    };
    if (argsCommon.visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.IN_ORG) {
        const inOrgViews = listViewClone.filter(v => v.visibleType === Constant.VISIBILITY_SETTING_TYPE.IN_ORG && v?.viewType === Constant.VIEW_TYPE.CUSTOM);
        if (inOrgViews.length > 0) {
            payload.syncInOrg = {
                corporationId: argsCommon.corporationSelectedId,
                projectId: argsCommon.projectSelectedId,
                reorderedInOrgViewIds: inOrgViews.map(v => v.id),
                triggerSource: Constant.SYNC_TRIGGER_SOURCE.IN_ORG
            };
        }
    }
    await editViewsResourceAPI(argsCommon.API, {
        method: Constant.UPDATE_VIEW_RESOURCE_METHOD.UPDATE_ORDER_VIEW_KNOWLEDGE,
        updateViewDto: JSON.stringify(payload)
    });
    argsCommon.setIsLoadingView(false);
};

export const onDragViewEnd = async (result, argsCommon) => {
    const visibilityKnowledgeAtom = argsCommon.visibilityKnowledgeAtom;
    const userDetail = argsCommon.userDetail;
    const userId = userDetail.id;
    if (!result.destination) return;
    let listViewClone = cloneDeep(argsCommon.listView);
    let listViewShow = listViewClone.filter(v => v.status === Constant.STATUS_VIEW.SHOW);

    // get index in listViewShow
    let sourceIndex = result.source.index;
    let desIndex = result.destination.index;

    // get item by index in listViewShow
    let itemSource = listViewShow[sourceIndex];
    let itemDes = listViewShow[desIndex];

    // get index in listView
    let sourceIndexListView = listViewClone.findIndex(v => v.id === itemSource.id);
    let desIndexListView = listViewClone.findIndex(v => v.id === itemDes.id);

    // move view in listView
    let [viewMove] = listViewClone.splice(sourceIndexListView, 1);
    viewMove.isMove = false;
    listViewClone.splice(desIndexListView, 0, viewMove);

    // Check visibility type to determine update logic
    if (visibilityKnowledgeAtom === Constant.VISIBILITY_SETTING_TYPE.PROJECT) {
        await updateViewOrderForProject(listViewClone, userId, argsCommon);
    } else {
        await updateViewOrderForOtherVisibility(listViewClone, argsCommon);
    }

    // Scroll to the view that was just moved
    // Wait for DOM to update after setListView
    setTimeout(() => {
        const viewElement = document.querySelector(`[data-view-id="${viewMove.id}"]`);
        if (viewElement) {
            const container = document.querySelector('#container-knowledge');
            if (container) {
                const elementRect = viewElement.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                
                // Check if view is already visible
                if (elementRect.left < containerRect.left || 
                    elementRect.right > containerRect.right) {
                    // Scroll to center the moved view
                    const scrollLeft = container.scrollLeft + 
                        (elementRect.left - containerRect.left) - 
                        (containerRect.width / 2) + 
                        (elementRect.width / 2);
                    
                    container.scrollTo({
                        left: scrollLeft,
                        behavior: 'smooth'
                    });
                }
            }
        }
    }, 100);
};

let timeoutEvent;
export const onWheel = event => {
    const container = document.querySelector('#container-knowledge');
    if (!container) return;

    // Convert vertical scroll to horizontal scroll
    container.scrollLeft +=
        event.deltaY > 0 ? Constant.SCROLL_LEFT_CHANGE : Constant.SCROLL_LEFT_CHANGE * -1;
    event.stopPropagation();

    // Simplified snap scrolling - snap to first visible view
    if (timeoutEvent) clearTimeout(timeoutEvent);
    timeoutEvent = setTimeout(() => {
        const nodeListView = document.querySelectorAll('.item-knowledge');
        const containerRect = container.getBoundingClientRect();

        // Find first view that is visible in viewport (left >= container left)
        for (let i = 0; i < nodeListView.length; i++) {
            const itemRect = nodeListView[i].getBoundingClientRect();
            
            // If this view is in viewport (left >= container left)
            if (itemRect.left >= containerRect.left) {
                // Snap to this view - scroll to align view at container start
                container.scrollLeft += itemRect.left - containerRect.left;
                break;
            }
        }
    }, Constant.TRIGGER_TIMEOUT_WHEEL_END);
};

export const isDisplayBtnSettingViewIcon = (
    isCustomer,
    userRoleInProject,
    viewStructure,
    isViewFromKnowledgePanel
) => {
    let visibleType = viewStructure.visibility;
    if (!Utils.isEmptyString(isViewFromKnowledgePanel)) {
        if (isViewFromKnowledgePanel !== Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) return false;
        if (
            userRoleInProject === 'MEMBER' &&
            visibleType !== Constant.VISIBILITY_SETTING_TYPE.PRIVATE && visibleType !== Constant.VISIBILITY_SETTING_TYPE.PROJECT
        ) {
            return false;
        }

        return true;
    }

    if (isCustomer) return false;
    if (
        userRoleInProject === 'MEMBER' &&
        visibleType !== Constant.VISIBILITY_SETTING_TYPE.PRIVATE && visibleType !== Constant.VISIBILITY_SETTING_TYPE.PROJECT
    ) {
        return false;
    }

    return true;
};
